/*
 * ototo-ds-rails.js — two rail/card interactions, shared by ds-showcase and
 * ds-universe (both build their rails from ds-product-card):
 *
 *   1. In-card image gallery. On a mouse, hovering a card peeks its SECOND image;
 *      leaving snaps back to the first. Arrows step through up to four images and
 *      the dots read out the position. Slides 2–4 hold their URL in data-ot-src
 *      and are fetched on first show, so the rail costs one request per card up
 *      front, not one per image.
 *
 *   2. Rail scroll arrows. Prev/next scroll the rail ~one viewport; each hides at
 *      its end. Desktop only — a touchscreen swipes (the arrows are display:none
 *      under 750px), so this just keeps their state honest if one is shown.
 *
 * Idempotent: safe to include from both sections on a page that has both. Every
 * element is guarded with a dataset flag, so a second run binds nothing twice.
 */
(function () {
  'use strict';

  function initGallery(media) {
    if (media.dataset.otGalleryReady) return;
    media.dataset.otGalleryReady = '1';

    var slides = [].slice.call(media.querySelectorAll('.ot-card__slide'));
    if (slides.length < 2) return;
    var dots = [].slice.call(media.querySelectorAll('.ot-card__dot'));
    var card = media.closest('.ot-card');
    var cur = 0;

    function ensureSrc(i) {
      var im = slides[i];
      if (im && !im.getAttribute('src') && im.dataset.otSrc) im.src = im.dataset.otSrc;
    }
    function show(i) {
      cur = (i + slides.length) % slides.length;
      ensureSrc(cur);
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === cur); });
    }

    var prev = media.querySelector('[data-ot-prev]');
    var next = media.querySelector('[data-ot-next]');
    /* The arrows sit inside the media's <a> siblings, not the link — but stop the
       event anyway so a fast click never falls through to the product link. */
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(cur - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(cur + 1); });

    /* Hover-peek only where a mouse can hover. Leaving resets to the first shot
       so every card rests on its packshot. */
    if (card && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      card.addEventListener('pointerenter', function () { show(1); });
      card.addEventListener('pointerleave', function () { show(0); });
    }
  }

  function initRail(wrap) {
    if (wrap.dataset.otRailReady) return;
    wrap.dataset.otRailReady = '1';

    /* .ot-reels: the home "Seen in the wild" strip uses the same arrows (2026-10-15). */
    var rail = wrap.querySelector('.ot-rail, .ot-reels');
    if (!rail) return;
    var prev = wrap.querySelector('[data-ot-rail-prev]');
    var next = wrap.querySelector('[data-ot-rail-next]');

    function step() { return Math.max(rail.clientWidth * 0.85, 200); }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.hidden = rail.scrollLeft <= 2;
      if (next) next.hidden = max <= 2 || rail.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    /* A universe panel is display:none until its tile is hovered; recompute the
       arrows the moment the rail is actually laid out and on screen. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function () { update(); }).observe(wrap);
    }
    update();
  }

  function initAll() {
    document.querySelectorAll('.ot-card__media[data-ot-gallery]').forEach(initGallery);
    document.querySelectorAll('.ot-railwrap').forEach(initRail);
  }

  window.__otDsRailsInit = initAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
